import Image from 'next/image'
import Link from 'next/link'
import { truncateString } from 'sanity'

import { PortalIcon } from '~/components/icons/PortalIcon'
import { urlForImage } from '~/lib/sanity.image'
import { Deployed, Showcase, Tools } from '~/lib/sanity.queries'

export default function BasicCard({
  content,
}: {
  content: Tools | Showcase | Deployed
}) {
  return (
    <Link href={content.url} target="_blank">
      <div className="bg-grey-150 rounded-24 overflow-hidden p-6 max-w-430 w-[320px] sm:w-[430px] h-full flex-shrink-0 flex flex-col gap-3 select-none">
        <div className="bg-black rounded-full w-16 h-16 relative overflow-hidden">
          <Image
            src={urlForImage(content.image).auto('format').url()}
            alt={content.title}
            className="animate-fade-in object-cover"
            sizes="64px"
            fill
            priority
          />
        </div>
        <div className="flex flex-row items-center justify-between">
          <h3 className="text-25 text-gradient truncate pr-4">
            {content.title}
          </h3>
          <PortalIcon className="flex-shrink-0" width={20} height={20} />
        </div>
        <p className="body-small text-grey mt-auto">
          {truncateString(content.body, 120)}
        </p>
      </div>
    </Link>
  )
}

export const BasicCardSkeleton = () => {
  return (
    <div className="bg-grey-150 rounded-24 overflow-hidden p-6 max-w-430 w-[326px] sm:w-[430px] aspect-square flex-shrink-0 gap-6 flex flex-col opacity-0">
      <div className="bg-grey-100 rounded-2xl aspect-9/5 relative overflow-hidden animate-pulse-soft">
        <div className="w-full h-full bg-grey-100" />
      </div>
      <div className="flex flex-row items-center justify-between gap-6">
        <div className="w-1/2 h-6 rounded-md bg-grey-100" />
        <div className="w-1/4 h-6 rounded-md bg-grey-100" />
      </div>
      <div className="w-full h-24 rounded-md bg-grey-100" />
    </div>
  )
}

export const BasicCardSpacer = () => {
  return (
    <div className="overflow-hidden p-6 max-w-430 w-[326px] sm:w-[430px] aspect-square flex-shrink-0 opacity-0"></div>
  )
}
